import { useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import iconSet from "components/cards/nearby-listings-card/icon-set";

import styles from "./styles.module.css";

const CheckBoxItem = ({
  title,
  name,
  checkBoxClass,
  displayClass,
  titleClass,
  showImage,
  showCheckBoxFooter,
  iconClass,
  checkBoxLength,
  badge,
  ...props
}) => {
  const checkBoxRef = useRef(null);

  const handleWrapper = () => {
    if (checkBoxRef.current) {
      checkBoxRef.current.click();
    }
  };

  const checkBoxClasses = classNames({
    [styles.label]: true,
    [checkBoxClass]: checkBoxClass,
    [styles.positionClass]: showImage,
    [styles.titleWithBadge]: badge,
  });

  const displayClasses = classNames({
    [styles.display]: true,
    [displayClass]: displayClass,
  });

  const titleClasses = classNames({
    [styles.title]: true,
    [titleClass]: titleClass,
    [styles.titleWithShowImage]: showImage,
  });

  const checkbox = (
    <>
      <input ref={checkBoxRef} className={styles.input} type="checkbox" name={name} {...props} />
      <div className={displayClasses}></div>
    </>
  );

  return (
    <span className={checkBoxClasses} onClick={handleWrapper}>
      {!showCheckBoxFooter && checkbox}
      {showImage && <div className={iconClass}>{iconSet?.find((x) => x.id === name).icon}</div>}
      <div className={titleClasses}>{title}</div>
      {badge && (
        <div className={styles.badge}>
          <span className={styles.dot} />
          {badge}
        </div>
      )}
      {checkBoxLength && <span className={styles.checkBoxLength}>{`(${checkBoxLength})`}</span>}
      {showCheckBoxFooter && checkbox}
    </span>
  );
};

CheckBoxItem.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  checkBoxClass: PropTypes.any,
  name: PropTypes.any,
  displayClass: PropTypes.any,
  image: PropTypes.any,
  showImage: PropTypes.any,
  showCheckBoxFooter: PropTypes.any,
  titleClass: PropTypes.any,
  iconClass: PropTypes.any,
  checkBoxLength: PropTypes.any,
  badge: PropTypes.string,
};

export default CheckBoxItem;
